module.exports = __webpack_public_path__ + "img/luxuryyacht_thumb_03.67cbe60e.jpg";